import isEqual from 'react-fast-compare';
/**
 * This function returns a function that when given an event handler, it will call it
 * and, if the event wasn't prevented in the handler, will call the callback handler.
 * A good use case is when you want to allow a component to receive an external
 * prop to handle an event (ex: onChange) but you also want to perform some logic on
 * the same event
 * @param handler external event handler
 * @param callback callback event handler
 * @template {React.SyntheticEvent} TEvent
 */
export function wrapEvent(handler, callback) {
    return function (event) {
        handler && handler(event);
        if (!event.defaultPrevented) {
            return callback && callback(event);
        }
    };
}
/**
 * Converts a numeric value
 */
export var toPx = function (value) {
    return !isNaN(value) ? value + "px" : value;
};
/**
 * Converts a string to an id in the format "some-id-here"
 */
export var strToID = function (str, prefix) {
    if (str === void 0) { str = ''; }
    if (prefix === void 0) { prefix = ''; }
    var id = str.split(' ').join('-').replace(/_/g, '-').toLowerCase();
    return prefix ? prefix + "-" + id : id;
};
/**
 * Generates a simple cryptographically weak id based on a prefix. Good for making sure
 * an element id or label is unique
 * @param prefix prefix for the id
 */
export function genId(prefix) {
    // This should be a noop in tests
    if (process.env.NODE_ENV === 'test') {
        return prefix;
    }
    return prefix + "-" + Math.random().toString(32).substr(2, 8);
}
/**
 * Determines if the given url is absolute. Useful for deciding if a url is intended to
 * lead to a local or external page.
 * @param url string being checked
 */
export function isUrlAbsolute(url) {
    if (typeof url !== 'string') {
        return false;
    }
    return (url.indexOf('://') > 0 ||
        url.indexOf('//') === 0 ||
        url.indexOf('mailto:') === 0);
}
/**
 * Returns the parent of an element based on the number of levels;
 * @param el: base HTMLElement to get parent
 * @param levels: number of parent levels (default is 1)
 */
export var getParentElement = function (el, levels) {
    if (typeof levels !== 'number')
        levels = 1;
    var parentEl = el;
    while (levels) {
        parentEl = parentEl && parentEl.parentElement;
        levels--;
    }
    return parentEl;
};
/**
 * Determine if component is functional
 * @param Component
 */
export var isFunctionalComponent = function (Component) {
    return typeof Component === 'object' && typeof Component.type === 'function';
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
export var noop = function () { };
export var isDifferent = function (value1, value2) {
    return !isEqual(Number.isInteger(value1) ? value1.toString() : value1, Number.isInteger(value2) ? value2.toString() : value2);
};
export var sortArray = function (arr) {
    if (!arr.length)
        return arr;
    return isObject(arr[0])
        ? arr.sort(function (a, b) { return a.id - b.id; })
        : arr.sort();
};
export var isObject = function (value) {
    return typeof value === 'object' && value !== null;
};
export var sleep = function () { return new Promise(function (resolve) { return setTimeout(resolve, 500); }); };
export function get(obj, path, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    var travel = function (regexp) {
        return String.prototype.split
            .call("" + path, regexp)
            .filter(Boolean)
            .reduce(function (res, key) { return (res !== null && res !== undefined ? res[key] : res); }, obj);
    };
    var result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return result === undefined || result === obj ? defaultValue : result;
}
export function pickBy(object) {
    var obj = {};
    for (var key in object) {
        if (object[key]) {
            obj[key] = object[key];
        }
    }
    return obj;
}
export function range(start, end) {
    return Array.from({ length: end - start }, function (_, i) { return start + i; });
}
//# sourceMappingURL=index.js.map